import React from 'react';

const TrackAndTrace = (props) => (
    <svg
        width="22px"
        height="32px"
        viewBox="0 0 22 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/T&amp;T b</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-387.000000, -1632.000000)">
                <g id="Icon/T&amp;T-b" transform="translate(387.000000, 1632.000000)">
                    <path
                        d="M7.2980456,12.25 L8.48735046,13.7491608 L12.215,12.853 L14.711731,12.2525177 L14.71,12.253 L14.7228462,12.25 L18.056333,12.25 C18.3299648,12.25 18.5818803,12.3990221 18.7136474,12.6388383 L21.4073144,17.5413122 C21.4681196,17.6519777 21.5,17.7762039 21.5,17.9024739 L21.5,31 C21.5,31.4142136 21.1642136,31.75 20.75,31.75 L1.25,31.75 C0.835786438,31.75 0.5,31.4142136 0.5,31 L0.5,17.9024739 C0.5,17.7762039 0.531880401,17.6519777 0.592685621,17.5413122 L3.28635261,12.6388383 C3.41811973,12.3990221 3.67003518,12.25 3.94366699,12.25 L7.2980456,12.25 Z M20,18.25 L2,18.25 L2,30.25 L20,30.25 L20,18.25 Z M8,27.25 L8,29.5 L3.5,29.5 L3.5,27.25 L8,27.25 Z M14.71,12.253 L12.215,12.853 L8.49114504,13.75 L4.385,13.75 L2.737,16.75 L19.261,16.75 L17.6135,13.75 L13.4525663,13.75 L14.71,12.253 Z"
                        id="🎨-Color"
                        fill="#000000"
                    ></path>
                    <path
                        d="M11,0.85 C14.0556303,0.85 16.4,3.1300871 16.4,6.2602329 C16.4,8.64460899 14.7953735,11.6041644 11.6089119,15.1722725 L11.2956073,15.5194742 L10.9999313,15.8438244 L10.7043303,15.5194057 C7.3097863,11.7939323 5.6,8.71981618 5.6,6.2602329 C5.6,3.12861858 7.94359187,0.85 11,0.85 Z M11,2.151 C8.72214287,2.151 7,3.92816501 7,6.40594499 C7,8.31830837 8.24082229,10.8056961 10.7403999,13.8401042 L11,14.151 L11.50094,13.543341 C13.6793415,10.8419535 14.8344776,8.58752255 14.9834505,6.79635069 L14.9958633,6.59923883 L15,6.40594499 C15,3.92946716 13.2771337,2.151 11,2.151 Z M11,4.47140641 C12.1045695,4.47140641 13,5.36683691 13,6.47140641 C13,7.57597591 12.1045695,8.47140641 11,8.47140641 C9.8954305,8.47140641 9,7.57597591 9,6.47140641 C9,5.36683691 9.8954305,4.47140641 11,4.47140641 Z M11,5.62140641 C10.530558,5.62140641 10.15,6.00196437 10.15,6.47140641 C10.15,6.94084845 10.530558,7.32140641 11,7.32140641 C11.469442,7.32140641 11.85,6.94084845 11.85,6.47140641 C11.85,6.00196437 11.469442,5.62140641 11,5.62140641 Z"
                        id="🎨-Color"
                        fill="#000000"
                        fill-rule="nonzero"
                    ></path>
                    <g id="Icon/Map/Location/16" transform="translate(6.000000, 2.250000)"></g>
                </g>
            </g>
        </g>
    </svg>
);

export default TrackAndTrace;
